import React, { Component } from "react";
import { Header, Segment, Image, Button, Modal, Dimmer, Loader } from "semantic-ui-react";
import request from "../../utils/request";

class HelpApp extends Component {
  state = {
    settings: {
      apk_filename: "bump.apk"
    },
    qrCode: '',
    paxQrCode: '',
    qrCodeSize: "medium",
    apkType: ""
  };

  display = (type) => { // open modal and handle callback
    let callback = (type === "paxApk") ? this.getPaxApkQrCode : this.getApkQrCode;
    this.setState({ apkType: type, open: true, active: true }, callback);
  };
  close = () => this.setState({ open: false });
  loader = () => this.setState({ active: false });
  increaseSize = () => this.setState({ qrCodeSize: "large" });
  decreaseSize = () => this.setState({ qrCodeSize: "small" });
  resetSize = () => this.setState({ qrCodeSize: "medium" });

  getApkUrl = e => {
    e && e.preventDefault();
    let payload = { is_pax: false };
    return request.post(this, "api:/apk", payload).then(resp => {
      // handle success
      if (resp && resp.url) {
        window.open(resp.url)
      }
    });
  };
  getPaxApkUrl = e => {
    e && e.preventDefault();
    let payload = { is_pax: true };
    return request.post(this, "api:/apk", payload).then(resp => {
      // handle success
      if (resp && resp.url) {
        window.open(resp.url)
      }
    });
  };
  getApkQrCode = () => {
    return request.getQrCode(this, "api:/apk-qr-code").then(resp => {
      // handle success
      if (resp) {
        this.setState({
          qrCode: resp
        })
      }
    });
  }
  getPaxApkQrCode = () => {
    return request.getQrCode(this, "api:/apk-qr-code/pax").then(resp => {
      // handle success
      if (resp) {
        this.setState({
          paxQrCode: resp
        })
      }
    });
  }
  returnQrCode = () => { // return appropriate qr code
    const { apkType, qrCode, paxQrCode } = this.state;
    switch (apkType) {
      case "apk": return qrCode;
      case "paxApk": return paxQrCode;
    }
  }
  render() {
    const apkFilename = this.state.settings.apk_filename;
    const { open, active, qrCodeSize } = this.state;

    // Using the Date object to get the midnight UTC time
    let date = new Date();
    date.setUTCHours(0, 0, 0, 0);  // Midnight UTC

    // Getting the milliseconds since 1970-01-01 00:00:00 UTC
    let midnightUTC = date.getTime();

    // Getting the UTC day of the month and year
    let dayOfMonth = date.getUTCDate();
    let year = date.getUTCFullYear();

    let divisor = dayOfMonth + year + 1;

    // Extracting the first eight digits from midnightUTC
    let firstEightDigits = String(midnightUTC).substring(0, 8);

    // Calculating the reprintPassword
    let reprintPassword = Math.floor(parseInt(firstEightDigits, 10) / divisor);

    return (
      <Segment basic>
        <Header as="h2">
          <Header.Subheader>
            Your Android application for tablets may be downloaded from the links
            below.
          </Header.Subheader>
        </Header>

        <Header as="h2">
          QR Codes are only valid for 10 minutes!
        </Header>

        <Modal
          closeIcon
          onClose={this.close}
          open={open}
          size="large"
          className="qrCodeModal"
        >
          <Modal.Content className="qrCodeModalContent">
            <Dimmer active={active} inverted>
              <Loader>Loading</Loader>
            </Dimmer>
            <Image src={this.returnQrCode()} onLoad={this.loader} size={qrCodeSize} centered />
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.increaseSize} circular icon='search plus' floated="left" />
            <Button onClick={this.decreaseSize} circular icon='search minus' floated="left" />
            <Button onClick={this.resetSize} circular icon='refresh' floated="left" />
            <Button onClick={this.close}>Close</Button>
          </Modal.Actions>
        </Modal>

        <Header as="h3">
          BUMP APK
        </Header>
        <Button onClick={this.getApkUrl}>
          Download
        </Button>
        <Button onClick={() => this.display("apk")}>
          Get new Qr Code
        </Button>

        <Header as="h3">
          PAX APK
        </Header>
        <Button onClick={this.getPaxApkUrl}>
          Download
        </Button>
        <Button onClick={() => this.display("paxApk")}>
          Get new Qr Code
        </Button>

        <Header as="h3">
          To setup the Bump application on a new Android tablet, please follow
          the steps below:
        </Header>
        <Header as="h4">Bluetooth Printer Pairing:</Header>
        <ol>
          <li>Make sure your mobile printer is turned on.</li>
          <li>Load the &quot;Settings&quot; app from your Android device.</li>
          <li>
            Tap on Bluetooth, then tap &quot;Scan&quot; to find your printer.
          </li>
          <li>
            Look on the bottom of the mobile printer for a &quot;Serial&quot;
            number, then tap on the Bluetooth device listed on your tablet that
            matches this serial number.
          </li>
          <li>
            If you are asked to enter a PIN number, enter &quot;0&quot;. Note
            the PIN could also be &quot;0000&quot; if &quot;0&quot; does not
            work.
          </li>
        </ol>
        <Header as="h4">Android Application Installation</Header>
        <ol>
          <li>
            Open the browser app on your Android device and download the app
            from the link above.
          </li>
          <li>
            Once the download has begun, swipe downwards from the top of the
            device to view your notifications area. You should see the download
            named &quot;{apkFilename}&quot; listed here.
          </li>
          <li>
            Tap on the &quot;{apkFilename}&quot; file in your notifications
            list.
          </li>
          <li>
            You *may* see an &quot;Install Blocked&quot; message. If so, tap the
            &quot;Settings&quot; button. If not, continue to step #6.
          </li>
          <li>
            Check the box that says &quot;Unknown Sources&quot; on this page,
            and then tap &quot;OK&quot; from the next pop-up.
          </li>
          <li>
            Tap the &quot;Install&quot; button on the bottom-right corner.
          </li>
          <li>
            Wait for the app to install, then tap &quot;Open&quot;.
          </li>
        </ol>

        <Header as="h4">Authorize the Device</Header>
        <ol>
          <li>
            Log into the Manager Panel and click on &quot;Devices&quot; in the
            top menu.
          </li>
          <li>
            On this page, you will see a device named "Unregistered Device"
            listed at the top. Click the icon on the right side of the table to
            edit the device, then enter a name for the device in the "NAME:"
            field.
          </li>
          <li>Click the "Save" button to save the device.</li>
        </ol>

        <Header as="h4">The tablet is now setup and ready for sales.</Header>

        <p>Reprint order Password: <span style={{ fontWeight: 'bold' }}>{reprintPassword}</span></p>

      </Segment>
    );
  }
}

export default HelpApp;
